module.exports = __webpack_public_path__ + "fonts/poppins-medium-webfont.c8f61f28.woff2";